module.exports = __webpack_public_path__ + "media/src/images/icons/download/white-8e35023777a24c5bd76c6825d0db2811.svg";